import { I18n } from 'react-redux-i18n';

import { api, mergeParams, wrapParams } from '../../api';
import { SHOW_LOADING, HIDE_LOADING } from './types/loadingTypes';

import { showToast } from  './toastrActions';


export function companyByUserId(userId) {

  return (dispatch) => {

    dispatch({
      type: SHOW_LOADING,
    });

    return new Promise((resolve, reject) => {

      api.get('Company/CompanyByUserId', { params: { userId } }).then((response) => {

        dispatch({
          type: HIDE_LOADING,
        });

        resolve(response.data.return);

      }, (error) => {

        dispatch({
          type: HIDE_LOADING,
        });

        reject(error.response.data.return);

      });

    });

  };

}

export function companyByHoldingId(holdingId) {

  return (dispatch) => {

    dispatch({
      type: SHOW_LOADING,
    });

    return new Promise((resolve, reject) => {

      api.get('Company/CompanyByHoldingId', { params: { holdingId } }).then((response) => {

        dispatch({
          type: HIDE_LOADING,
        });

        resolve(response.data.return);

      }, (error) => {

        dispatch({
          type: HIDE_LOADING,
        });

        reject(error.response.data.return);

      });

    });

  };

}

export function getCompanyById(companyId) {

  return (dispatch) => {

    dispatch({
      type: SHOW_LOADING,
    });

    return new Promise((resolve, reject) => {

      api.get('Company/EditCompany', { params: { companyId } }).then((response) => {

        dispatch({
          type: HIDE_LOADING,
        });

        resolve(response.data.return);

      }, (error) => {

        dispatch({
          type: HIDE_LOADING,
        });

        reject(error.response.data.return);

      });

    });

  };

}

export function save(data) {

  return (dispatch) => {

    dispatch({
      type: SHOW_LOADING,
    });

    let request;

    if (data.idCompany) request = api.put('Company/UpdateCompany', wrapParams(data));
    else request = api.post('Company/CreateCompany', wrapParams(data));


    return new Promise((resolve, reject) => {

      request.then(
        (response) => {

          dispatch({
            type: HIDE_LOADING,
          });

          showToast('success', '', 'Dados da Empresa salvos com sucesso')

          resolve(response);

        },
        (error) => {

          dispatch({
            type: HIDE_LOADING,
          });

          showToast('error', '', 'Ocorreu um erro ao salvar os dados da Empresa')

          reject(error.response.data.errors);

        },
      );

    });

  };

}

export function deleteCompany(idCompany) {

  return (dispatch) => {

    dispatch({
      type: SHOW_LOADING,
      
    });

    return new Promise((resolve, reject) => {

      api.delete('Company/DeleteCompany', { params: { idCompany } }).then(() => {

        dispatch({
          type: HIDE_LOADING,
        });

        showToast('success', '', 'Registro de Empresa deletado')
        resolve();

      }, (error) => {

        dispatch({
          type: HIDE_LOADING,
        });

        showToast('error', '', 'Ocorreu um erro ao deletar os dados da Empresa')
        reject(error.response.data.errors);

      });

    });

  };

}



// WEBPACK FOOTER //
// ./src/redux/actions/companyActions.js